.icon {
  width: 22px;
  height: 22px;
}

.dark {
  display: light-dark(block, none);
}

.light {
  display: light-dark(none, block);
}
